<template>
  <main>
    <header class="page-header">
      <h2>Oops, this page hasn't been baked yet!</h2>
    </header>
    <div class="wrapper">
      <div class="message">
        Please use the menu at the top of the page to continue browsing
      </div>
      <div class="image-container">
        <ImageLoader :src='randomImage' lazy="true" class="image"/>
      </div>
      <div class="message">
        A delicious creation that has finished baking
      </div>
    </div>
    <div class="wrapper not-found__blog-post-container" v-if="false">
      <!-- DEV NOTE: This section has been disabled until the blog is implemented -->
      <div class="not-found__while-you-wait-title">While you wait, have a read of my latest blog post</div>
      <div class="not-found__blog-post">
        Either embed the latest blog post here, or just show the excerpt, and the user can then click on Read More, to
        be taken through to the blog posts page
      </div>
    </div>
    <div class="wrapper" v-if="false">
      <!-- DEV NOTE: This section has been disabled until the blog is implemented -->
      <p>Or use the menu at the top to navigate to a page that is ready</p>
      <ul class="not-found__menu">
        <template v-for="(link, index) in $store.state.routerLinks">
          <li class="nav-link">
            <router-link :to="link.path" exact>{{link.label}}</router-link>
          </li>
        </template>
      </ul>
    </div>
  </main>
</template>

<script>
  import ImageLoader from '../components/ImageLoader'

  export default {
    name: 'NotFound',
    components: {
      ImageLoader
    },
    computed: {

      /**
       * Grab the first random image set in the store and display it on the page
       *
       * @returns {*}
       */
      randomImage () {
        if (typeof this.$store.state.randomImages.one.paths !== 'undefined') {
          return this.$store.state.randomImages.one.paths.medium
        }

        return ''
      }
    },
    data: function () {
      return {}
    },
    beforeMount: function () {
      // Before the component is mounted, change the random creations images
      this.$store.dispatch('randomizeImages')
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// NotFound.vue?0049a284